import type {
  ConversationFileAttachment,
  DocType,
  DocumentDTO,
} from '@eriko/shared-types';
import { apiClient } from '../lib/api';
import { ENDPOINTS } from './endpoints';

export async function listDocuments(params?: {
  docType?: DocType;
  status?: string;
  /** Exclude docs already linked to a CONFIRMED/AUTO_MATCHED reconciliation match. */
  excludeMatched?: boolean;
}): Promise<DocumentDTO[]> {
  const qs = new URLSearchParams();
  if (params?.docType) qs.set('docType', params.docType);
  if (params?.status) qs.set('status', params.status);
  if (params?.excludeMatched) qs.set('excludeMatched', 'true');
  const suffix = qs.toString() ? `?${qs.toString()}` : '';
  const res = await apiClient.get<DocumentDTO[]>(`${ENDPOINTS.documents.list}${suffix}`);
  return res.data;
}

export async function updateDocument(
  id: string,
  body: { docType?: DocType },
): Promise<DocumentDTO> {
  const res = await apiClient.patch<DocumentDTO>(ENDPOINTS.documents.detail(id), body);
  return res.data;
}

export async function deleteDocument(id: string): Promise<{ id: string }> {
  const res = await apiClient.delete<{ id: string }>(ENDPOINTS.documents.detail(id));
  return res.data;
}

export interface ProcessResponse {
  conversationId: string;
  seedMessageContent: string;
  attachments: ConversationFileAttachment[];
}

export async function processDocument(id: string): Promise<ProcessResponse> {
  const res = await apiClient.post<ProcessResponse>(ENDPOINTS.documents.process(id), {});
  return res.data;
}

export async function retryDocument(id: string): Promise<ProcessResponse> {
  const res = await apiClient.post<ProcessResponse>(ENDPOINTS.documents.retry(id), {});
  return res.data;
}
